import { createAction } from 'redux-actions';
import { actionPrefix } from './constants';
export const pushPopoverWithOptions = createAction(`${actionPrefix}.PUSH_POPOVER`, (id, options)=>{
    return {
        id,
        options
    };
});
export const pushPopover = (id, options = {})=>pushPopoverWithOptions(id, options);
export const removePopover = createAction(`${actionPrefix}.REMOVE_POPOVER`, (id)=>id);

//# sourceMappingURL=actionCreators.js.map